// Substituted at build (webpack/Vite define) or bundle deploy time.
declare global {
  var DATADOG_CLIENT_TOKEN: string | undefined;
  var REDO_API_URL: string | undefined;
}

export const DATADOG_CLIENT_TOKEN = globalThis.DATADOG_CLIENT_TOKEN ?? null;

export const REDO_API_URL = globalThis.REDO_API_URL ?? "http://localhost:8888";
// console.log("REDO_API_URL 12: ", REDO_API_URL);
